module.exports = __webpack_public_path__ + "img/AGR-i-1-II.f36d208e.png";